import React from 'react';
import Layout from "../../../basic/Layout/Layout.js";
var InnerLayout = _ref => {
  var {
    content,
    cta
  } = _ref;
  return cta ? /*#__PURE__*/React.createElement(Layout, {
    align: "justify"
  }, content, cta) : /*#__PURE__*/React.createElement(React.Fragment, null, content);
};
export default InnerLayout;